'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var utils = require('@chakra-ui/utils');

/**
 * Get the common `aria-*` attributes for the circular progress components
 */
function getProgressProps(options) {
  var _options$value = options.value,
    value = _options$value === void 0 ? 0 : _options$value,
    min = options.min,
    max = options.max,
    valueText = options.valueText,
    getValueText = options.getValueText,
    isIndeterminate = options.isIndeterminate;

  /**
   * Calculates percentage of progress with given value, max & min
   */
  var percent = utils.valueToPercent(value, min, max);

  /**
   * Returns the aria-valuetext (valueText if given or a function that returns the desired valueText instead of the value)
   */
  var getAriaValueText = function getAriaValueText() {
    if (value == null) return undefined;
    return utils.isFunction(getValueText) ? getValueText(value, percent) : valueText;
  };
  return {
    bind: {
      'data-indeterminate': isIndeterminate ? '' : undefined,
      'aria-valuemax': max,
      'aria-valuemin': min,
      'aria-valuenow': isIndeterminate ? undefined : value,
      'aria-valuetext': getAriaValueText(),
      role: 'progressbar'
    },
    percent: percent,
    value: value
  };
}
exports.getProgressProps = getProgressProps;